import { Css } from "@homebound/beam";
import { QueryTable } from "src/components";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useProjectDashboardFinancialsQuery } from "src/routes/projects/dashboard/components/Financials/ProjectDashboardFinancials.generated";
import {
  createFinancialsTableColumns,
  createFinancialsTableRows,
} from "src/routes/projects/dashboard/components/Financials/utils";
import { Tile, TileBaseProps } from "src/routes/projects/dashboard/components/Tile";
import { createBudgetUrl } from "src/RouteUrls";

export function FinancesTile(props: TileBaseProps) {
  const { projectId } = useRouteParams<{ projectId: string }>();
  const query = useProjectDashboardFinancialsQuery({ variables: { projectId } });

  return (
    <Tile href={createBudgetUrl(projectId)} {...props} xss={Css.pt0.$}>
      <QueryTable
        query={query}
        createRows={createFinancialsTableRows}
        columns={createFinancialsTableColumns(true)}
        style={{ allWhite: true, rowHeight: "fixed" }}
      />
    </Tile>
  );
}
